import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import { AuthContext } from "../context/AuthContext";
import jwt_decode from "jwt-decode";
import {
  TextField,
  Button,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  LockOutlined,
  Home,
} from "@mui/icons-material";

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await api.post("users/login/", formData);
      const accessToken = response.data.access;
      login(accessToken);

      const decoded = jwt_decode(accessToken);
      const userRole = decoded.role;

      if (userRole === "admin") {
        localStorage.removeItem("student_selected_menu");
        localStorage.removeItem("student_dashboard_tab");
        localStorage.setItem("last_login_role", "admin");
        navigate("/admin/dashboard");
      } else if (userRole === "student") {
        localStorage.removeItem("admin_selected_menu");
        localStorage.removeItem("admin_dashboard_tab");
        localStorage.setItem("last_login_role", "student");
        navigate("/student/dashboard");
      } else {
        setError("Unknown role. Cannot redirect.");
      }
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-5xl w-full grid grid-cols-1 md:grid-cols-2 gap-8 bg-white shadow-lg rounded-xl overflow-hidden relative">
        {/* Home Button */}
        <button
          type="button"
          onClick={() => navigate("/")}
          className="absolute top-3 right-3 z-10 p-2 rounded-full bg-white shadow hover:bg-gray-100 transition-colors"
          title="Home"
        >
          <Home fontSize="medium" className="text-blue-600" />
        </button>
        {/* SVG Illustration */}
        <div className="hidden md:flex items-center justify-center bg-blue-50 p-8">
          <img
            src="images/login.svg" // or replace with your own SVG
            alt="Login Illustration"
            className="w-full max-w-md"
          />
        </div>
        {/* Login Form */}
        <div className="p-8 flex flex-col justify-center items-center">
          <img
            src="images/logo.png" // or replace with your own SVG
            alt="Logo"
            className="w-2/5 max-w-md mb-2"
          />
          <div className="mb-6 flex items-center gap-2 text-primaryText text-xl font-bold">
            <LockOutlined className="text-blue-700" />
            <Typography variant="h5">Login</Typography>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <TextField
              label="Username"
              variant="outlined"
              name="username"
              fullWidth
              required
              value={formData.username}
              onChange={handleChange}
            />
            <TextField
              label="Password"
              variant="outlined"
              type={showPassword ? "text" : "password"}
              name="password"
              fullWidth
              required
              value={formData.password}
              onChange={handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {error && (
              <Typography variant="body2" color="error">
                {error}
              </Typography>
            )}

            <Button
              type="submit"
              variant="contained"
              fullWidth
              className="bg-blue-700 text-white hover:bg-blue-800"
            >
              Login
            </Button>

            <div className="text-right">
              <a
                href="/forgot-password"
                className="text-sm text-blue-600 hover:underline"
              >
                Forgot Password?
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
